import React from 'react';
import classNames from './CompletedRecordingMenu.module.css';
import { observer } from 'mobx-react-lite';
import { saveRecordingFn, saveToHarFile } from '../../State/EvidenceDB/SaveRecording';
import { downloadReport } from './downloadReport';
import { ReportName, RecordingPanelState } from './RecordingPanelState';


export const CompletedRecordingMenu = observer(({ recordingPanelState }: { recordingPanelState: RecordingPanelState; }) => {
	const {recordingUuid, licenseCache, mayExportAllData, maySaveReports, primaryTabId} = recordingPanelState;
	const openLicensePage = () => {
		const licensePageUrl = 'https://datagowhere.org/';
		if (chrome != null && chrome.tabs != null) {
			chrome.tabs.create({url: licensePageUrl});
		} else {
			window.open(licensePageUrl, '_blank')?.focus();
		}
	}
	return (
		<div className={classNames.DropdownMenuContainer}>
			<div className={classNames.DropDownMenuName}>≡</div>
			<div className={classNames.DropdownMenuContent}>
				{/* <DropdownMenuItem onClick={ downloadStandaloneSearchReportFn(recordingViewState) }>
                Download Search Report
            </DropdownMenuItem> */}
				{ maySaveReports == false ? null : (
						<button onClick={() => downloadReport(recordingPanelState) }>
							Download&nbsp;{ReportName[primaryTabId]}
						</button>
				)}
				{ mayExportAllData == false ? null : (
					<button onClick={() => saveToHarFile(recordingUuid)}>
						Save HAR
					</button>
				)}
				<button onClick={saveRecordingFn(licenseCache, recordingUuid)}>{
					mayExportAllData ?
						(<>Export all recorded evidence</>) :
						(<>Export videos and page content</>)
				}
				</button>
				{ mayExportAllData ? null : (<>
					<div className={classNames.comment}>
						Exporting network traffic requires a license
					</div>
					<button onClick={openLicensePage}>
						Get a license
					</button>
				</>)}
			</div>
		</div>
	);
});
